/**
 * Created by haiying_zheng on 2017/7/31.
 *
 * @param obj
 */
export function type(obj) {
	const type = {
		'[object Array]': 'array',
		'[object Boolean]': 'boolean',
		'[object Date]': 'date',
		'[object Function]': 'function',
		'[object Number]': 'number',
		'[object Object]': 'object',
		'[object RegExp]': 'regexp',
		'[object String]': 'string'
	}

	if (obj === null) {
		return obj + ''
	}
	return typeof obj === 'object' || typeof obj === 'function'
		? type[Object.prototype.toString.call(obj)] || 'object'
		: typeof obj
}

/**
 * @param arr
 */
export function isArray(arr) {
	return Object.prototype.toString.call(arr).includes('Array')
}

/**
 * @param obj
 */
export function isWindow(obj) {
	return obj !== null && obj === obj.window
}

/**
 * @param obj
 */
export function isPlainObject(obj) {
	return (
		type(obj) === 'object' && !isWindow(obj) && Object.getPrototypeOf(obj) === Object.prototype
	)
}

export const extend = (function () {
	/**
	 * @param target
	 * @param source
	 * @param deep
	 */
	function extend(target, source, deep) {
		for (const key in source)
			if (source.hasOwnProperty(key)) {
				if (deep && (isPlainObject(source[key]) || isArray(source[key]))) {
					if (isPlainObject(source[key]) && !isPlainObject(target[key])) target[key] = {}
					if (isArray(source[key]) && !isArray(target[key])) target[key] = []
					extend(target[key], source[key], deep)
				} else if (source[key] !== undefined) target[key] = source[key]
			}
	}
	return function (target) {
		let deep,
			args = Array.prototype.slice.call(arguments, 1)
		if (typeof target === 'boolean') {
			deep = target
			target = args.shift()
		}
		args.forEach(function (arg) {
			extend(target, arg, deep)
		})
		return target
	}
})()

/**
 *
 */
export function isWechat() {
	return navigator.userAgent.toLowerCase().includes('micromessenger')
}
/**
 *
 */
export function isQing() {
	return navigator.userAgent.match(/Qing\/.*;(iOS|iPhone|Android).*/)
}

/**
 *
 */
export function getOS() {
	return navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
		? 'iOS'
		: navigator.userAgent.match(/Android/i)
		? 'Android'
		: ''
}

export const Counter = (function () {
	const Counter = function (max, cb) {
		this.max = max
		this.current = 0
		this.cb = cb
		this.cacheData = []
	}

	Counter.prototype.count = function (data) {
		this.cacheData.push(data)
		++this.current && this.current === this.max && this.cb(this.cacheData)
	}
	Counter.prototype.reset = function () {
		this.current = 0
		this.cacheData = []
	}

	return Counter
})()

// 获取网址参数
/**
 * @param name
 */
export function getUrlParam(name) {
	const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
	const r = window.location.search.substr(1).match(reg)
	if (r !== null) {
		return decodeURIComponent(r[2])
	}
	return null
}

// 柯里化
/**
 * @param fn
 * @param args
 */
export function curry(fn, args) {
	return function () {
		let arr = [].slice.call(arguments)

		if (args !== undefined) {
			arr = arr.concat(args)
		}

		if (arr.length < fn.length) {
			curry(fn, arr)
		}

		fn.apply(null, arr)
	}
}

// 通用正则校验
/**
 * @param targetString
 * @param reg
 */
export function check(targetString, reg) {
	return reg.test(targetString)
}

export const validate = {
	mobile(val) {
		return !!val && /^1[3456789][0-9]{9}$/.test(val)
	},
	tel(val) {
		return (
			!!val &&
			/^((0[0-9]{2,3}(\-)?)?[2-9][0-9]{6,7}|((00852|\+852)\-)?([2-3][0-9]{7}))+(\-[0-9]{1,4})?$/i.test(
				val
			)
		)
	},
	email(val) {
		return !!val && /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/i.test(val)
	},
	idCard() {
		// 以后用上
		return true
	},
	strongPwd(val) {
		return !!val && /^(?=.*?[A-Za-z]+)(?=.*?[0-9]+).*$/.test(val)
	}
}

import _base64 from 'lib/base64'
export const Base64 = _base64

import _rsa from 'lib/rsa'
export const rsa = _rsa

// 浮点四则运算
export const calculate = (function () {
	/**
	 * @param obj
	 */
	function isInteger(obj) {
		return Math.floor(obj) === obj
	}
	/**
	 * @param floatNum
	 */
	function toInteger(floatNum) {
		const ret = { times: 1, num: 0 }
		const isNegative = floatNum < 0

		if (isInteger(floatNum)) {
			ret.num = floatNum
			return ret
		}

		let strfi = floatNum + '',
			dotPos = strfi.indexOf('.'),
			len = strfi.substr(dotPos + 1).length,
			times = Math.pow(10, len),
			intNum = parseInt(Math.abs(floatNum) * times + 0.5, 10)

		ret.times = times

		if (isNegative) {
			intNum = -intNum
		}

		ret.num = intNum
		return ret
	}
	/**
	 * @param a
	 * @param b
	 * @param op
	 */
	function operation(a, b, op) {
		let o1 = toInteger(a),
			o2 = toInteger(b),
			n1 = o1.num,
			n2 = o2.num,
			t1 = o1.times,
			t2 = o2.times,
			max = t1 > t2 ? t1 : t2,
			result = null

		switch (op) {
			case 'add':
				if (t1 === t2) {
					// 两个小数位数相同
					result = n1 + n2
				} else if (t1 > t2) {
					// o1 小数位 大于 o2
					result = n1 + n2 * (t1 / t2)
				} else {
					// o1 小数位 小于 o2
					result = n1 * (t2 / t1) + n2
				}
				return result / max
			case 'subtract':
				if (t1 === t2) {
					result = n1 - n2
				} else if (t1 > t2) {
					result = n1 - n2 * (t1 / t2)
				} else {
					result = n1 * (t2 / t1) - n2
				}
				return result / max
			case 'multiply':
				result = (n1 * n2) / (t1 * t2)
				return result
			case 'divide':
				result = (n1 / n2) * (t2 / t1)
				return result
		}
	}

	return {
		add(a, b) {
			return operation(a, b, 'add')
		},
		sub(a, b) {
			return operation(a, b, 'subtract')
		},
		multiplication(a, b) {
			return operation(a, b, 'multiply')
		},
		division(a, b) {
			return operation(a, b, 'divide')
		}
	}
})()

/**
 * @param str
 */
export function trim(str) {
	str = str || ''
	str = str.toString()
	return str.replace(/^\s|\s$/g, '').replace(/\s+/g, ' ')
}

/**
 * @param elem
 * @param cls
 */
export function hasClass(elem, cls) {
	elem = elem || {}
	return new RegExp('\\b' + cls + '\\b').test(elem.className)
}
/**
 * @param elem
 * @param cls
 */
export function addClass(elem, cls) {
	elem = elem || {}
	hasClass(elem, cls) || (elem.className += ' ' + cls)
	elem.className = trim(elem.className)
}
/**
 * @param elem
 * @param cls
 */
export function removeClass(elem, cls) {
	elem = elem || {}
	if (hasClass(elem, cls)) {
		const reg = new RegExp('\\b' + cls + '\\b')
		elem.className = elem.className.replace(reg, '')
	}
}

/**
 * @param el
 * @param str
 */
export function parent(el, str) {
	const node = el.parentElement
	if (node.className == str || node.tagName.toLocaleUpperCase() == str.toLocaleUpperCase()) {
		return node
	} else {
		return parent(node, str)
	}
}

/**
 * @param name
 */
export function getCookie(name) {
	let arr,
		reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)')
	arr = document.cookie.match(reg)
	if (arr) {
		return decodeURIComponent(arr[2])
	} else {
		return null
	}
}

/**
 * @param name
 * @param value
 * @param day
 * @param path
 */
export function setCookie(name, value, day, path) {
	const exp = new Date()
	day = day || 1
	path = path || '/'
	exp.setTime(exp.getTime() + day * 24 * 60 * 60 * 1000)
	document.cookie =
		name + '=' + encodeURIComponent(value) + ';expires=' + exp.toGMTString() + ';path=' + path
}

/**
 *
 */
export function getAccessToken() {
	let access_token = getUrlParam('access_token')
	if (!access_token) {
		access_token = getCookie('access_token')
		console.log('access_token 来自 cookie')
	} else {
		console.log('access_token 来自 url')
	}

	if (access_token) {
		setCookie('access_token', access_token)
		setCookie('token', access_token)
		console.log('设置 access_token 成功')
	} else {
		console.log('未获取到 access_token')
	}

	return access_token
}

/**
 * @param num
 */
export function chineseSeq(num) {
	/**
	 * @param numArr
	 */
	function trimZero(numArr) {
		let start = 0,
			end = numArr.length - 1

		while (numArr[start] === '零' || numArr[start] === '') {
			numArr[start] = ''
			start++
		}
		while (numArr[end] === '零' || numArr[end] === '') {
			numArr[end] = ''
			end--
		}
	}

	num = parseInt(num)

	let base = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'],
		carry = ['', '十', '百', '千', '', '十', '百', '千', '', '十', '百', '千', '万'],
		valArr = new Array(num.toString().length),
		numArr = new Array(valArr.length),
		i = valArr.length - 1, // 位索引
		ci = 0, // 位值表示索引
		wFlag = false, // 万的值是否为0
		yFlag = false, // 亿的值是否为0
		r

	while (i >= 0) {
		r = num % 10

		if (r > 0) {
			valArr[i] = base[r] + carry[ci]

			// 末位为十，十万，十亿都没有一
			if ((ci === 1 || ci === 5 || ci === 9) && i === 0 && r === 1) {
				valArr[i] = carry[ci]
			}

			// 判断万,十万,百万,千万是否有值
			if (ci >= 4 && ci <= 7) {
				if (!wFlag) {
					valArr[i] = valArr[i] + '万'
					wFlag = true
				}
			}

			// 判断亿,十亿,百亿,千亿,万亿是否有值
			if (ci >= 8 && ci <= 12) {
				if (!yFlag) {
					valArr[i] = valArr[i] + '亿'
					yFlag = true
				}
			}
		} else {
			if (valArr[i + 1] === '零' || valArr[i + 1] === '') {
				valArr[i] = ''
			} else {
				valArr[i] = base[r]
			}
		}
		numArr[i] = r
		num = parseInt(num / 10)
		i--
		ci++
	}

	trimZero(valArr)
	return valArr.join('')
}
